/** Concierge download tracker — always go through here before any APK. */
export const SELFOS_DOWNLOAD_TRACKER =
  'https://concierge.rolemodel.ai/api/selfos/download?version=0.2.2-beta&versionCode=4&channel=essence-site';

export const SELFOS_BETA = {
  version: '0.2.2-beta',
  versionCode: 4,
  androidMin: 'Android 9+ (API 28+)',
  sha256: '3725EF8917A78AA4183F69563B30C8AB9254CF0EF6E0124E39353D7E508E4D10',
  supportEmail: 'support@rolemodel.ai',
} as const;

/**
 * Start download via Concierge tracker GET.
 * Prefer navigation so the browser follows the 302 → APK (fetch would pull the
 * binary into JS / hit CORS and wrongly fall through to “hosting not live”).
 */
export function startSelfOsDownload(): void {
  window.location.assign(SELFOS_DOWNLOAD_TRACKER);
}
